import { useEffect } from "react";
import { Link, useSearchParams } from "react-router-dom";
import Layout from "@/components/layout/Layout";
import SEO from "@/components/SEO";
import { Button } from "@/components/ui/button";
import { CheckCircle2, Package, Mail } from "lucide-react";
import { useCart } from "@/context/CartContext";

export default function CheckoutSuccess() {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get("session_id");
  const { clearCart } = useCart();

  useEffect(() => {
    if (sessionId) clearCart();
  }, [sessionId, clearCart]);

  return (
    <Layout>
      <SEO title="Order Confirmed" description="Thank you for your order at Pronto-Letters.com." canonical="/checkout/success" />
      <div className="container flex flex-col items-center py-24 text-center">
        <CheckCircle2 className="h-20 w-20 text-accent" />
        <h1 className="mt-6 font-display text-3xl font-bold">Order Confirmed!</h1>
        <p className="mt-3 max-w-md text-muted-foreground">
          Thank you for your purchase. Your payment was successful and your order is on its way.
        </p>
        {sessionId && (
          <p className="mt-2 text-xs text-muted-foreground">
            Order reference: <span className="font-mono">{sessionId.slice(-8).toUpperCase()}</span>
          </p>
        )}

        <div className="mt-8 grid w-full max-w-md gap-4 rounded-lg border bg-card p-6 text-left">
          <div className="flex items-start gap-3">
            <Mail className="h-5 w-5 shrink-0 text-accent" />
            <div>
              <p className="text-sm font-semibold">Confirmation email</p>
              <p className="text-sm text-muted-foreground">A Stripe receipt has been sent to your email.</p>
            </div>
          </div>
          <div className="flex items-start gap-3">
            <Package className="h-5 w-5 shrink-0 text-accent" />
            <div>
              <p className="text-sm font-semibold">Shipping</p>
              <p className="text-sm text-muted-foreground">Ships from Cannon Falls, MN via UPS. Tracking will follow.</p>
            </div>
          </div>
        </div>

        <div className="mt-8 flex flex-col gap-3 sm:flex-row">
          <Button asChild className="bg-accent text-accent-foreground hover:bg-accent/90">
            <Link to="/shop">Continue Shopping</Link>
          </Button>
          <Button asChild variant="outline">
            <Link to="/">Return Home</Link>
          </Button>
        </div>

        <p className="mt-8 text-xs text-muted-foreground">
          Questions?{" "}
          <a href="mailto:nick@moonriversigns.com" className="text-accent hover:underline">
            nick@moonriversigns.com
          </a>{" "}
          · (314) 369-8649
        </p>
      </div>
    </Layout>
  );
}